import { mountSingleRace } from './utils/mount-single-race.js';
mountSingleRace('CA-84431').catch(console.error);
